import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { APP_ROUTES } from '@app/app-routes.const';
import { UserService } from '../services/user.service';
import { ToastService } from '@app/services/toast.service';

export const HomeGuard: CanActivateFn = (route, state) => {
  const toastSrv = inject(ToastService);
  const userSrv = inject(UserService);
  const router = inject(Router);

  if (!userSrv.isLoggedIn()) {
    return router.createUrlTree([APP_ROUTES.LOGIN], {
      queryParams: {
        returnUrl: state.url,
      },
    });
  }

  if (userSrv.isAdmin()) {
    return true;
  }

  if (userSrv.isPartner()) {
    return router.parseUrl(`/${APP_ROUTES.LABELS}`);
  }

  toastSrv.showToast('Forbidden!!! You do not have permission to access this page');
  return false;
};
